export default {
  scoreMetadata: {
    step: 'Шаг',
    createSelfTestsTitle: 'Тесты на самооценку',
    appointTestsTitle: 'Назначение оценки',
    approvalTestsTitle: 'Отправка оценки на согласование',
    editTestTitle: 'Редактировать оценку',
    descriptionTitle: 'Описание задачи/проекта',
    selectOfEvaluatedTitle: 'Выберите оцениваемых',
    addingEvaluatedGroups: 'Добавление групп оценивающих',
    selectExpertsByEvaluatedTitle:
      'Выберите оценивающих экспертов, новый состав участников будет отправлен на согласование руководителя',
    appointTestsProcessTitle: 'Назначено',
    appointTestsProcessText:
      'Вы можете закрыть данное окно, тесты будут назначены в фоновом режиме. Обновите страницу через некоторое время, чтобы увидеть созданные тесты.',
    approvalTestsProcessTitle: 'Отправлено',
    approvalTestsProcessText:
      'Вы можете закрыть данное окно, тесты будут отправлены в фоновом режиме.',
    formLabels: {
      period: 'Установить расписание',
      skipSelfEval: 'Без самооценки',
      approvalBySupervisor: 'Подтверждение руководителем в оценке 360',
      approvalByEvaluated: 'Согласовать с оцениваемым сотрудником',
      hideReport: 'Скрыть отчёт для оцениваемого сотрудника',
      enabledComments: 'Включить комментарии к компетенции',
      requiredComments: 'Обязательные комментарии к компетенции',
      enabledDescription: 'Включить описание задачи/проекта',
      description: 'Описание задачи/проекта',
    },
    formPlaceholders: {
      description: 'Опишите задачу или проект, в рамках которого будет выполняться оценка',
    },
    buttons: {
      startWithoutApproval: 'Начать без согласования',
      reApprove: 'Согласовать повторно',
      addGroup: 'Добавить группу',
      assignApprover: 'Назначить согласующим',
      removeApprover: 'Убрать из согласующих',
    },
    tooltips: {
      approver: 'Согласовывает состав участников оценки 360',
      period:
        'Пользователи могут пройти тест только в указанный период времени. По истечении срока тест становится недоступен для прохождения',
      changePeriod:
        'Расписание изменится у всей группы тестов. Пользователи могут пройти тесты только в указанный период времени. По истечении срока тесты станут недоступны для прохождения',
      remind: 'Последнее напоминание',
      closed: 'Тест закрыт для прохождения',
    },
    menuReport: {
      forSupervisor: 'Отчёт для руководителя',
      forEmployee: 'Отчёт для сотрудника',
    },
    uncompletedTest: 'Тест не пройден',
    canceledTest: 'Тест отменён',
    teamReports: {
      title: 'Командные отчёты',
      description: 'Для формирования командного отчёта выберите команду из списка',
    },
    exportTypes: {
      pivotExport: 'Общие средние оценки',
      pivotTested: 'Статус завершенности',
      gradePivotExport: 'Статистика по командам',
      usersGradePivotExport: 'Сырые оценки по командам',
      scoreSkillsExport: 'Оценка компетенций',
      passingExport: 'Прохождение оценки',
      massRoadmap: 'Карта развития',
      fixedRoadmaps: 'Зафиксированные планы',
    },
    descriptions: {
      180: 'Оценка 180 - в оценке принимает участие только оцениваемый и лидер команды',
      360: 'Оценка 360 - в оценке участвует вся команда целиком и автоматически распределяются по ролям',
      soft: 'Soft skills они же “гибкие навыки” - универсальные компетенции, не связанные с конкретной предметной областью, повышающие эффективность работы и взаимодействия с другими людьми',
      hard: 'Hard skills они же “жёсткие” навыки - профессиональные навыки, которые можно получать в процессе обучения, данный тип навыков можно измерить при помощи экзамена или тестирования',
      period:
        'Пользователи смогут пройти оценку только в указанный период времени, по истечении срока оценка станет недоступна.<br/>Дата начала периода - дата, в которую отправятся уведомления для начала оценки.<br/>Если включён процесс согласования состава участников, письма на утверждение состава отправятся сразу при нажатии на кнопку «Назначить оценку».',
      skipSelfEval:
        'Оценка по методу 360, но оцениваемый участник не будет проходить опрос. Отчёт по завершению оценки также не будет доступен оцениваемому сотруднику. Показ отчёта можно будет включить в любой момент.',
      approvalBySupervisor:
        'Тест запустится только после того, как руководитель в оценке 360 подтвердит состав участников.',
      approvalByEvaluated:
        'Оцениваемый сотрудник сможет скорректировать состав участников и отправить оценку руководителю для окончательного согласования.',
      hideReport:
        'Отчёт будет скрыт для оцениваемого сотрудника. Показ отчёта можно будет разрешить позднее, в любой момент проведения оценки.',
      enabledComments: 'Включены комментарии к каждой компетенции при прохождении оценки',
      requiredComments:
        'Включены обязательные комментарии к каждой компетенции при прохождении оценки',
      comments: {
        all: 'В процессе оценки респонденты должны будут обязательно оставить комментарий для каждой компетенции',
        score:
          'В процессе оценки респонденты должны будут обязательно оставить комментарий только для тех компетенций, для которых поставят оценку ниже или равной заданной',
      },
      enabledDescription:
        'Сотрудник сможет описать задачу или проект, в рамках которых будет выполняться оценка',
      addExpertGroups: 'Достигнут лимит. Добавить группу можно, если удалить текущую',
    },
    commentTypes: {
      all: 'Все',
      score: 'Ниже оценки',
    },
    reportIsUnavailable: {
      tests360: 'Нет пройденных тестов 360 для формирования отчёта',
      personal: 'Нет пройденных тестов для формирования отчёта',
    },
    // confirm dialogs
    confirmGetReport: {
      title: 'Сформировать отчёт?',
      text: 'Не все участники команды прошли тестирование, полученные данные могут оказаться недостоверными.',
      button: 'Да, сформировать',
    },
    confirmCreateTests: {
      title: 'Вы уверены?',
      text: 'Период прохождения тестирования истёк',
      button: 'Да, назначить',
    },
    confirmCancelTest: {
      title: 'Отменить тест?',
      text: 'Вы уверены, что хотите отменить тест? Тест будет аннулирован, и его придётся запустить заново.',
      button: 'Да, отменить',
    },
    confirmReApproveTest: {
      title: 'Отправить тест на повторное согласование?',
      text: 'Вы уверены, что хотите отправить оценку на повторное согласование с руководителем?',
      button: 'Да, отправить',
    },
    confirmStartWithoutApproval: {
      title: 'Начать оценку без согласования?',
      text: 'Вы уверены, что хотите начать оценку, не дожидаясь согласования?',
      button: 'Да, начать',
    },
    confirmDeleteExpertGroup: {
      title: 'Удалить группу {name}?',
      description: 'Любые изменения групп будут применены ко всем оценкам в этом назначении',
      text: 'В группе имеются сотрудники. Действительно удалить группу?',
    },
    confirmSetHiddenReports360: {
      hide: {
        title: 'Скрыть отчёты для сотрудников?',
        text: 'У оцениваемых сотрудников на странице «Мне назначено» не будет возможности просмотра отчёта по выбранным тестам.',
        button: 'Да, скрыть',
      },
      show: {
        title: 'Показать отчёты для сотрудников?',
        text: 'У оцениваемых сотрудников на странице «Мне назначено» будет возможность просмотра отчёта по выбранным тестам.',
        button: 'Да, показать',
      },
    },
    confirmCloseTests360: {
      close: {
        title: 'Закрыть оценки для прохождения?',
        text: 'У сотрудников, принимающих участие в оценке, не будет возможности пройти тесты.',
        button: 'Да, закрыть',
      },
      open: {
        title: 'Открыть оценки для прохождения?',
        text: 'У сотрудников, принимающих участие в оценке, будет возможность пройти тесты.',
        button: 'Да, открыть',
      },
    },
    confirmCreateReminders: {
      title: 'Отправить напоминания?',
      defaultText:
        'Участникам выбранных тестов будут отправлены письма с напоминанием о тестировании.',
      warningText:
        'Будет отправлено {msg_count} пользователям, которые не прошли или не согласовали оценку.',
      warningTextForClosedTests: 'По закрытым оценкам письма отправлены не будут.',
      button: 'Да, отправить',
    },
    confirmDeleteTests360: {
      title: 'Действительно удалить оценку 360?',
      text: 'Удалённые тесты нельзя будет восстановить, а сформированный отчёт и карта развития не будут доступны пользователю. Вы уверены?',
    },
    confirmGetReport360: {
      title: 'Сформировать отчёт?',
      text: 'Не все участники теста заполнили опросник, полученные данные могут оказаться недостоверными.',
      button: 'Да, сформировать',
    },
    confirmCreateRoadmap360: {
      title: 'Сформировать план развития?',
      text: 'Сформировать план развития на основе этого теста',
      button: 'Да, сформировать',
    },
    //
    successMessages: {
      appoint: {
        title: 'Оценка успешно назначена',
        text: 'Письма с инструкциями по прохождению отправлены на адреса электронной почты, указанные при регистрации',
      },
      approval: {
        title: 'Тестирование отправлено на согласование',
        text: 'Оценка отправлена на подтверждение',
      },
      reject: {
        title: 'Тестирование отклонено',
        text: 'Оценка отправлена на редактирование',
      },
      cancelled: {
        title: 'Тестирование отменено',
        text: 'Оценка успешно отменена',
      },
    },
    infoMessages: {
      selectedSoftSkills: 'Доступны для выбора специализации, в которых есть soft skills',
      selectedHardSkills: 'Доступны для выбора специализации, в которых есть hard skills',
      selectedAllSkills: 'Доступны для выбора специализации, в которых есть оба типа навыков',
    },
    errorMessages: {
      getAutoExperts:
        'Не удалось назначить экспертов из орг. структуры. В роли экспертов будут назначены участники команды.',
      appointAllTests: 'Не удалось назначить ни одного теста',
      appointSomeTests: 'Некоторые тесты были не назначены',
      approvalAllTests: 'Не удалось отправить на согласование ни одного теста',
      approvalSomeTests: 'Некоторые тесты не были отправлены на согласование',
      rejectAllTests: 'Не удалось отклонить оценку',
      approvedAllTests: 'Не удалось согласовать оценку',
      checkStatuses: 'Не удалось получить статус назначения тестов',
      changeStatus: 'Не удалось изменить статус теста',
      getDescription: 'Не удалось загрузить описание задачи/проекта',
      setDescription: 'Не удалось сохранить описание задачи/проекта',
    },
    errorValidationMessages: {
      skillType: 'Выберите хотя бы один тип навыков',
      selectExperts: 'Есть специализации, по которым не выбран ни один эксперт',
      noExperts: 'Не выбран ни один эксперт',
      selectApprover: 'Выберите одного руководителя, который должен согласовать оценку 360',
    },
    changeTests360SettingsDialog: {
      title: 'Настройка назначения оценки',
      successMessage: 'Настройки успешно сохранены',
      errorMessages: {
        getTests360Settings: 'Не удалось получить настройки',
        changeTests360Settings: 'Не удалось изменить настройки',
      },
    },
  },
};
